import type { BlogPost } from '../../../../../../../types';

export const useCover = (coverMedia: BlogPost['coverMedia']) => {
  const cover = coverMedia?.image?.url
    ? coverMedia.image
    : coverMedia?.video?.thumbnail;

  const url = cover?.url ?? '';
  const width = cover?.width;
  const height = cover?.height;

  let aspectRatio = 1;

  if (width && height) {
    aspectRatio = +(width / height).toFixed(4);
  }

  return {
    url,
    width,
    height,
    aspectRatio,
  };
};
